import React from 'react'
import {
  VersionSectionWrapper,
  PageTitle,
  SubheadingWrapper,
  VersionText,
  DateText,
  DateIcon,
  ListItem,
  ListText
} from './styles'
import { Collapse, Table, Tag } from 'antd'
import { BugOutlined, FireOutlined, TeamOutlined, BulbOutlined } from '@ant-design/icons'
import {
  CONTRIBUTORS_VERSION_0,
  CONTRIBUTORS_VERSION_1,
  CONTRIBUTORS_VERSION_2,
  CONTRIBUTORS_VERSION_2_1,
  CONTRIBUTORS_VERSION_3
} from './data'
import { contributorsCompare } from '../../utils/utils'

const { Panel } = Collapse

const ReleaseNotes = () => {
  CONTRIBUTORS_VERSION_3.sort(contributorsCompare)
  CONTRIBUTORS_VERSION_2_1.sort(contributorsCompare)
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Role',
      key: 'role',
      displayName: 'Team Table',
      dataIndex: 'role',
      // eslint-disable-next-line
      render: (_, { role }) => (
        <>
          {role.map((tag) => {
            let color = tag.length > 5 && tag.length < 8 ? 'green' : 'orange'
            if (tag === 'Developer') {
              color = 'geekblue'
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            )
          })}
        </>
      )
    }
  ]

  return (
    <div style={{ paddingBottom: '180px' }}>
      <PageTitle>Release Notes</PageTitle>
      <VersionSectionWrapper>
        <SubheadingWrapper>
          <VersionText>Version 3.0</VersionText>
          <DateText>
            <DateIcon />
            Aug 2023 - Aug 2023
          </DateText>
        </SubheadingWrapper>
        <Collapse accordion>
          {/* Features Panel */}
          <Panel
            header={
              <>
                <FireOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Features</span>
              </>
            }
            key='1'>
            <ul>
              <p style={{ fontSize: '16px', fontWeight: '600' }}>The application allows the user to:</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>
                  Export the user profile in two templates: Full Template and Business Analyst.
                </ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Improvements in the look and feel when exporting user profiles.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Improvements in user&apos;s permissions when accessing other profiles.</ListText>
              </ListItem>
            </ul>
          </Panel>
          {/* Bugs Fixed Panel */}
          <Panel
            header={
              <>
                <BugOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Bugs Fixed</span>
              </>
            }
            key='2'>
            <ul>
              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>View Profile</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>More intuitive titles in some sections.</ListText>
              </ListItem>
              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>Edit Profile</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fixed misplaced modal on experience selection.</ListText>
              </ListItem>
            </ul>
          </Panel>
          {/* Contributors Panel */}
          <Panel
            header={
              <>
                <TeamOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Contributors</span>
              </>
            }
            key='3'>
            <Table bordered columns={columns} dataSource={CONTRIBUTORS_VERSION_3} pagination={false} />
          </Panel>
        </Collapse>
      </VersionSectionWrapper>
      <VersionSectionWrapper>
        <SubheadingWrapper>
          <VersionText>Version 2.1</VersionText>
          <DateText>
            <DateIcon />
            Jun 2023 - Aug 2023
          </DateText>
        </SubheadingWrapper>
        <Collapse accordion>
          {/* Features Panel */}
          <Panel
            header={
              <>
                <FireOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Features</span>
              </>
            }
            key='1'>
            <ul>
              <p style={{ fontSize: '16px', fontWeight: '600' }}>The application allows the user to:</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>
                  Access user list for non-admin users.
                </ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Search in the profiles filters&apos; options by typing in the dropdown.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>It is more intuitive to know whether it is own or another profile viewed or edited.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>The user list is more adaptable to small screens.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>The application loads the admin sidebar buttons on startup.</ListText>
              </ListItem>
            </ul>
          </Panel>
          {/* Bugs Fixed Panel */}
          <Panel
            header={
              <>
                <BugOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Bugs Fixed</span>
              </>
            }
            key='2'>
            <ul>
              <p style={{ fontSize: '16px', fontWeight: '600' }}>User List</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fixed user list filters when the page is different from the first page.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fixed issues that prevented the admin and other users from saving search filters.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fixed issue when editing own profile and changing to view page.</ListText>
              </ListItem>

              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>Audit Profile</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fixed icon buttons disappearing when changing to another profile audit page.</ListText>
              </ListItem>
            </ul>
          </Panel>
          {/* Contributors Panel */}
          <Panel
            header={
              <>
                <TeamOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Contributors</span>
              </>
            }
            key='3'>
            <Table bordered columns={columns} dataSource={CONTRIBUTORS_VERSION_2_1} pagination={false} />
          </Panel>
        </Collapse>
      </VersionSectionWrapper>
      <VersionSectionWrapper>
        <SubheadingWrapper>
          <VersionText>Version 2.0</VersionText>
          <DateText>
            <DateIcon />
            Jan 2023 - Jun 2023
          </DateText>
        </SubheadingWrapper>
        <Collapse accordion>
          {/* Features Panel */}
          <Panel
            header={
              <>
                <FireOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Features</span>
              </>
            }
            key='1'>
            <ul>
              <p style={{ fontSize: '16px', fontWeight: '600' }}>The application allows the user to:</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>
                  Access any other user&#39;s public profile section (excluding professional experience)
                </ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Access to the user list</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Verify the grammar on their profile with Grammarly and Bing</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Friendly and easy accesible URL</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>See new field for last updated date.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Warning before refreshing the page with unsaved changes</ListText>
              </ListItem>
              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>Only for admin users:</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Added templates section on the sidebar</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Improvements on the look and feel when editing and exporting user&#39;s profiles</ListText>
              </ListItem>
            </ul>
          </Panel>
          {/* Bugs Fixed Panel */}
          <Panel
            header={
              <>
                <BugOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Bugs Fixed</span>
              </>
            }
            key='2'>
            <ul>
              <p style={{ fontSize: '16px', fontWeight: '600' }}>Login</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Added a redirection when trying to login instead of throwing a 500 error</ListText>
              </ListItem>

              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>View Profile</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fixed navigation issue</ListText>
              </ListItem>

              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>Edit Profile</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fixed capitalization in some titles and subtitles</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fixed the delete confirmation message</ListText>
              </ListItem>

              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>User List</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Added message when searching for a user and no result is found</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Modified styles to be usable on smaller screens</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Clearer wording for some of the column titles</ListText>
              </ListItem>
            </ul>
          </Panel>
          {/* Contributors Panel */}
          <Panel
            header={
              <>
                <TeamOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Contributors</span>
              </>
            }
            key='3'>
            <Table bordered columns={columns} dataSource={CONTRIBUTORS_VERSION_2} pagination={false} />
          </Panel>
        </Collapse>
      </VersionSectionWrapper>
      <VersionSectionWrapper>
        <SubheadingWrapper>
          <VersionText>Version 1.0</VersionText>
          <DateText>
            <DateIcon />
            Jan 2022 - Jan 2023
          </DateText>
        </SubheadingWrapper>
        <Collapse accordion>
          {/* Features Panel */}
          <Panel
            header={
              <>
                <FireOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Features</span>
              </>
            }
            key='1'>
            <ul>
              <p style={{ fontSize: '16px', fontWeight: '600' }}>The application allows the user to:</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>
                  Create its own profile including general information, spoken languages, educational background,
                  certifications and courses, experience, programming languages, databases, tools and techniques, soft
                  skills, and industry verticals.
                </ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Export its own curriculum as a Word document.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Add certifying entities, degree titles, and soft skills to the application.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>See the changes made in its own profile and the person who did it.</ListText>
              </ListItem>

              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>Only for admin users:</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>
                  Search for specific people and filter by name, email, user type, discipline, role, core skill, and
                  grade.
                </ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Delete users.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Enable admin access for other users.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>View and edit all resumes.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Export in PDF or Word the profile of any Endavan.</ListText>
              </ListItem>
            </ul>
          </Panel>
          {/* Bugs Fixed Panel */}
          <Panel
            header={
              <>
                <BugOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Bugs Fixed</span>
              </>
            }
            key='2'>
            <ul>
              <p style={{ fontSize: '16px', fontWeight: '600' }}>Login</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Issues credentials.</ListText>
              </ListItem>

              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>View Profile</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Missing information in Soft Skills.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Issues with visualization information.</ListText>
              </ListItem>

              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>Edit Profile</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Put on visible the Export button from this view.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fix the double records as certifications and it does not save.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Define the number of characters and the format of each field.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fix message of warning or error in some fields.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Cannot add a spoken language without a level.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>The information saved is not keeping it..</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Submit button message.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fix the error when the Skill name field was selected by user.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Order to show the experience from the user.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fix functionality of the Programming language.</ListText>
              </ListItem>

              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>Admin Panel</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fix capitalization and alignment of t some fields.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Filters don’t show records correctly.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Industry sector added should be visible on the list.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Role filter functionality.</ListText>
              </ListItem>

              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>Audit</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Not found.</ListText>
              </ListItem>

              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>Export</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Error in PDF and Word exports.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Dynamic color fields in the template.</ListText>
              </ListItem>

              <p style={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>Support</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Fix the support button which doesn’t launch any email client.</ListText>
              </ListItem>
            </ul>
          </Panel>
          {/* Contributors Panel */}
          <Panel
            header={
              <>
                <TeamOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Contributors</span>
              </>
            }
            key='3'>
            <Table bordered columns={columns} dataSource={CONTRIBUTORS_VERSION_1} pagination={false} />
          </Panel>
        </Collapse>
      </VersionSectionWrapper>

      <VersionSectionWrapper>
        <SubheadingWrapper>
          <VersionText>Version 0</VersionText>
          <DateText>
            <DateIcon />
            Aug 2021 - Dec 2021
          </DateText>
        </SubheadingWrapper>
        <Collapse accordion>
          {/* Discovery Panel */}
          <Panel
            header={
              <>
                <BulbOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Discovery Phase</span>
              </>
            }
            key='0'>
            <ul>
              <ListItem>
                <ListText>Build the vision of the product.</ListText>
              </ListItem>
              <ListItem>
                <ListText>Establish CI/CD approach.</ListText>
              </ListItem>
              <ListItem>
                <ListText>Build initial requirements and investigate the technology stack.</ListText>
              </ListItem>
              <ListItem>
                <ListText>Establish a budget of the infrastructure.</ListText>
              </ListItem>
            </ul>
          </Panel>
          {/* features panel */}
          <Panel
            header={
              <>
                <FireOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Features</span>
              </>
            }
            key='1'>
            <ul>
              <p style={{ fontSize: '16px', fontWeight: '600' }}>The application allows the user to:</p>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Authenticate in the application with your Endava user.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>
                  Create its own profile including general information, spoken languages, educational background,
                  certifications, experience, programming languages, databases, tools and frameworks, methodologies, and
                  soft skills.
                </ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>View and edit its own profile at any time.</ListText>
              </ListItem>
              <ListItem style={{ marginLeft: '30px' }}>
                <ListText>Export its own curriculum as a PDF.</ListText>
              </ListItem>
            </ul>
          </Panel>
          {/* Contributors Panel */}
          <Panel
            header={
              <>
                <TeamOutlined style={{ color: '#de411b', fontSize: '18px' }} />
                <span style={{ fontSize: '18px', paddingLeft: '10px' }}>Contributors</span>
              </>
            }
            key='2'>
            <Table bordered columns={columns} dataSource={CONTRIBUTORS_VERSION_0} pagination={false} />
          </Panel>
        </Collapse>
      </VersionSectionWrapper>
    </div>
  )
}

export default ReleaseNotes
